<template>
  <div class="tabcontentdiv">
    <div class="text-block-2">KLAUSELGRUPPEN</div>
    <div class="form-block w-form">
      <form @submit.prevent>
        <input
          v-model="searchString"
          type="text"
          class="text-field w-input"
          maxlength="256"
          name="name"
          data-name="Name"
          placeholder="Klausel suchen"
        />
      </form>
    </div>
    <div style="width: 100%;">
      <group
      v-for="g of clauseGroups"
      :key="g.id"
      :group="g"
      :clauses="queriedClauses"
      @sharePressed="insertClause"
    />
    </div>
  </div>
</template>

<script>
import Group from '@/components/Group'
import wordService from '@/service/wordService'
import groupmixin from '@/components/mixins/group.mixin'
import searchmixin from '@/components/mixins/search.mixin'
import HTTP from '@/service/httpservice'
const clauseDao = new HTTP('/search/clauses')
const documentDao = new HTTP('/document/base64')
export default {
  mixins: [groupmixin, searchmixin],
  components: { Group },
  data () {
    return {
      clauses: [],
      queriedClauses: []
    }
  },
  computed: {
    clauseGroups () {
      return this.groups.filter(g => g.type === 'CLAUSE')
    }
  },
  created () {
    clauseDao.get().then(res => {
      this.clauses = res.data
      this.$set(this, 'queriedClauses', this.clauses)
    })
  },
  watch: {
    searchString () {
      this.$set(this, 'queriedClauses', this.search(this.clauses, this.searchString))
    }
  },
  methods: {
    insertClause (clause) {
      window.analytics.track('[ADD-IN] INSERT CLAUSE - ' + clause.name, {
        id: clause.id,
        name: clause.name
      })
      documentDao.get(clause.id).then(res => {
        const base64Doc = res.data
        wordService.insertAt(base64Doc, 'base64')
      }).error(e => {
        console.error(e)
        wordService.insertAt(clause.richText)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/ClauseTab.vue